import { baseUrl } from '@percent/partner-dashboard/services/apiPaths'
import { PBPListResponse, PBPResponse } from '@percent/partner-dashboard/services/types/pbpResponses.types'
import { Fundraiser, FundraisersServiceCapabilities, GetFundraisersListProps } from './fundraisersService.types'

export const fundraisersService = ({ percentClient }: FundraisersServiceCapabilities) => ({
  getFundraisersList: (params: GetFundraisersListProps) => {
    const { status, query, featuredOnly, visibility, direction, ...otherParams } = params

    return percentClient.get<PBPListResponse<Fundraiser>>(`${baseUrl}partner/fundraisers`, {
      params: {
        ...otherParams,
        ...(status && { status }),
        ...(query && { query }),
        ...(featuredOnly && { featuredOnly }),
        ...(visibility && { visibility }),
        ...(direction && { direction })
      }
    })
  },
  closeFundraiser: (fundraiserId: string) => {
    return percentClient.post<PBPResponse<{ success?: boolean }>>(`${baseUrl}partner/fundraisers/${fundraiserId}/close`)
  },
  getFundraiserDetails: ({ fundraiserId }) => {
    return percentClient.get<PBPResponse<Fundraiser>>(`${baseUrl}partner/fundraisers/${fundraiserId}`)
  },
  reopenFundraiser: (fundraiserId: string) => {
    return percentClient.post<PBPResponse<{ success?: boolean }>>(
      `${baseUrl}partner/fundraisers/${fundraiserId}/reopen`
    )
  }
})
